import { jsx as _jsx } from "react/jsx-runtime";
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType, } from 'react-router-dom';
import App from '~/App';
import '~/styles/main.css';
if (process.env.SENTRY_ENABLED === 'true') {
    Sentry.init({
        dsn: process.env.SENTRY_DSN,
        environment: process.env.name,
        integrations: [
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.reactRouterV6Instrumentation(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes),
            }),
        ],
        tracesSampleRate: 1.0,
    });
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(_jsx(App, {}));
